// Mock Data für Dion Hair Clinic - Augenbrauentransplantation Landing Page

export const variant = "augenbrauen";
export const variantLabel = "Augenbrauentransplantation";

export const clinicInfo = {
  name: "Dion Hair Clinic",
  tagline: "Ihr Experte für Augenbrauentransplantation",
  phone: "+49 2161 2963017",
  email: "info@dionhairclinic.de",
  website: "www.dionhairclinic.de",
  address: {
    street: "Schürenweg 61",
    city: "41063 Mönchengladbach",
    country: "Deutschland"
  },
  openingHours: {
    weekdays: "Mo - Fr: 9:00 - 18:00 Uhr",
    saturday: "Sa: 10:00 - 14:00 Uhr",
    sunday: "So: Geschlossen"
  }
};

export const heroContent = {
  title: "Augenbrauentransplantation",
  subtitle: "Natürliche Schönheit, dauerhaft",
  description: "Volle, perfekt geformte Augenbrauen - die dauerhafte Alternative zu Microblading. Präzise Transplantation für natürliche Ergebnisse.",
  ctaPrimary: "Kostenlose Beratung",
  ctaSecondary: "Kostenlose Beratung",
  badge: "Spezialist für Augenbrauen",
  heroImage: "/images/Augenbrauen_Model.webp"
};

export const stats = [
  { value: "98%", label: "Zufriedene Patienten" },
  { value: "5.000+", label: "Erfolgreiche Behandlungen" },
  { value: "15+", label: "Jahre Erfahrung" },
  { value: "4.9★", label: "Google Bewertung" }
];

export const beforeAfterImages = [
  {
    id: 1,
    before: "/images/optimized/3pj0tfkg_image.webp",
    after: "/images/optimized/kh14ru9k_image.webp",
    title: "Patientin 1",
    grafts: "300 Grafts",
    technique: "Saphir FUE & DHI Hybrid"
  },
  {
    id: 2,
    before: "/images/optimized/o02vexie_image.webp",
    after: "/images/optimized/pcicmlva_image.webp",
    title: "Patientin 2",
    grafts: "350 Grafts",
    technique: "Saphir FUE & DHI Hybrid"
  },
  {
    id: 3,
    before: "/images/optimized/byg0oh01_image.webp",
    after: "/images/optimized/19qyzq3k_image.webp",
    title: "Patientin 3",
    grafts: "280 Grafts",
    technique: "Saphir FUE & DHI Hybrid"
  }
];

export const expertise = [
  {
    id: 1,
    icon: "Eye",
    title: "Natürliche Form",
    description: "Wir gestalten Ihre Augenbrauen passend zu Ihrer Gesichtsform für einen harmonischen, natürlichen Look."
  },
  {
    id: 2,
    icon: "Target",
    title: "Präzisionsarbeit",
    description: "Jedes einzelne Haar wird im optimalen Winkel implantiert, um natürliches Wachstum zu imitieren."
  },
  {
    id: 3,
    icon: "Sparkles",
    title: "Dauerhafte Lösung",
    description: "Anders als Microblading oder Permanent Make-up wachsen transplantierte Augenbrauen dauerhaft."
  },
  {
    id: 4,
    icon: "Heart",
    title: "Für alle Ursachen",
    description: "Ob Überzupfen, genetisch dünne Brauen, Narben oder Alopecia - wir finden die passende Lösung."
  },
  {
    id: 5,
    icon: "Shield",
    title: "Sichere Methode",
    description: "Die Transplantation erfolgt unter lokaler Betäubung und ist minimalinvasiv."
  },
  {
    id: 6,
    icon: "Award",
    title: "Spezialisiertes Team",
    description: "Unsere Ärzte haben jahrelange Erfahrung speziell in der Augenbrauentransplantation."
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Beratung & Design",
    description: "Wir analysieren Ihre Gesichtsform und entwerfen gemeinsam die perfekte Augenbrauenform für Sie.",
    icon: "MessageSquare"
  },
  {
    step: 2,
    title: "Vorzeichnung",
    description: "Am Behandlungstag zeichnen wir die neue Brauenform vor und Sie können sie vor dem Eingriff freigeben.",
    icon: "Sparkles"
  },
  {
    step: 3,
    title: "Transplantation",
    description: "Feine Haarfollikel werden aus dem Hinterkopf entnommen und einzeln in die Augenbrauenregion implantiert.",
    icon: "Stethoscope"
  },
  {
    step: 4,
    title: "Heilungsphase",
    description: "Kleine Krusten fallen nach 7-10 Tagen ab. Die Augenbrauen sehen dann bereits voller aus.",
    icon: "HeartHandshake"
  },
  {
    step: 5,
    title: "Ihr Ergebnis",
    description: "Nach 6-12 Monaten genießen Sie volle, natürliche Augenbrauen, die Sie normal stylen können.",
    icon: "Trophy"
  }
];

export const pricing = [
  {
    id: 1,
    name: "Augenbrauentransplantation",
    subtitle: "Long Hair FUE — komplett ohne Rasur",
    features: [
      "Long Hair FUE Technik — keine Rasur nötig",
      "Sofort sichtbares Ergebnis in voller Haarlänge",
      "Lokale Betäubung",
      "Individuelle Augenbrauenformgestaltung",
      "Nachsorgekit inklusive",
      "12 Monate Nachbetreuung"
    ],
    tiers: [
      { grafts: "Long Hair FUE (komplett ohne Rasur)", price: "4.499" }
    ],
    popular: true,
    isEyebrowPricing: true,
    isSimplePricing: true,
    monthlyFrom: "78"
  }
];

export const team = [
  {
    id: 1,
    name: "Dr. Sotirios Tsomkopoulos",
    role: "Facharzt für Thoraxchirurgie & Haartransplantationschirurg",
    video: "https://customer-assets.emergentagent.com/job_themeswitch-2/artifacts/wmewma40_video%285%29.mp4",
    image: "https://customer-assets.emergentagent.com/job_5a750e2c-9afa-457e-8878-f20f1025e07d/artifacts/x1tzbzpk_sortiris.jpeg",
    description: "Dr. Tsomkopoulos ist Facharzt für Thoraxchirurgie mit Approbation in Deutschland und der Schweiz. Er verfügt über langjährige Erfahrung als leitender Haartransplantationschirurg in renommierten Kliniken in Berlin, Basel und Thessaloniki.",
    specialization: "ISHRS-Mitglied, FUE & DHI Spezialist, Approbation DE/CH"
  },
  {
    id: 2,
    name: "Blerina Bevapi",
    role: "Fachärztin für Innere Medizin und Expertin für Haartransplantationen",
    video: "https://customer-assets.emergentagent.com/job_follicle-wizard/artifacts/if5w0ce2_bevapi.mp4",
    image: "/images/optimized/Blerina-Bevapi.webp",
    description: "Mit ihrer umfassenden medizinischen Expertise und spezialisiertem Wissen im Bereich Haartransplantationen sorgt Dr. Bevapi für höchste medizinische Standards und optimale Behandlungsergebnisse.",
    specialization: "Fachärztin für Innere Medizin, Spezialisierung auf Haartransplantationstechniken"
  },
  {
    id: 3,
    name: "Dilek Ergüney",
    role: "Medizinische Haartechnikerin",
    video: "https://customer-assets.emergentagent.com/job_follicle-wizard/artifacts/i3r32fur_ergueney.mp4",
    image: "/images/optimized/Dilek-Ergueney.webp",
    description: "Dilek Ergüney bringt umfangreiche Erfahrung in der präzisen Durchführung von Haartransplantationstechniken mit und ist spezialisiert auf die sorgfältige Handhabung von Haarfollikeln für optimale Ergebnisse.",
    specialization: "Zertifizierte medizinische Haartechnikerin mit Spezialisierung auf FUE- und DHI-Techniken"
  },
  {
    id: 4,
    name: "Songül Bulut",
    role: "Spezialistin für Haartransplantationen",
    video: "https://customer-assets.emergentagent.com/job_follicle-wizard/artifacts/mvg2maej_bulut.mp4",
    image: "/images/optimized/Songuel-Bulut.webp",
    description: "Songül Bulut absolvierte ihr Medizinstudium in der Türkei und sammelte jahrelange Erfahrung in führenden Haarkliniken weltweit. Ihre internationale Expertise garantiert erstklassige Behandlungsergebnisse.",
    specialization: "Medizinstudium in der Türkei, internationale Erfahrung in führenden Haarkliniken"
  }
];

export const clinicImages = [
  {
    id: 1,
    src: "/images/optimized/DionHairClinic_Eingang.webp",
    alt: "Klinik Eingang",
    title: "Unsere Klinik"
  },
  {
    id: 2,
    src: "/images/optimized/DionHairClinic_Flur.webp",
    alt: "Klinik Flur",
    title: "Moderner Flur"
  },
  {
    id: 3,
    src: "/images/optimized/DionHairClinic_OP_Raum.webp",
    alt: "OP Raum",
    title: "Steriler OP-Raum"
  },
  {
    id: 4,
    src: "/images/optimized/DionHairClinic_Wartebereich.webp",
    alt: "Wartebereich",
    title: "Eleganter Wartebereich"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sandra K.",
    location: "München",
    rating: 5,
    text: "Nach Jahren des Überzupfens hatte ich kaum noch Augenbrauen. Jetzt habe ich endlich wieder volle, natürliche Brauen. Ein Traum!",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&auto=format",
    treatment: "Verdichtung, 250 Grafts"
  },
  {
    id: 2,
    name: "Maria L.",
    location: "Köln",
    rating: 5,
    text: "Ich hatte eine Narbe in der Augenbraue nach einem Unfall. Die Transplantation hat sie komplett verdeckt. Fantastisches Ergebnis!",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&auto=format",
    treatment: "Narbenkorrektur, 100 Grafts"
  },
  {
    id: 3,
    name: "Jennifer M.",
    location: "Frankfurt",
    rating: 5,
    text: "Microblading musste ich alle paar Jahre erneuern. Die Transplantation war die beste Entscheidung - natürlich und dauerhaft!",
    image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=100&h=100&fit=crop&auto=format",
    treatment: "Vollrekonstruktion, 380 Grafts"
  }
];

export const faqItems = [
  {
    question: "Wie unterscheidet sich eine Augenbrauentransplantation von Microblading?",
    answer: "Bei der Transplantation wachsen echte Haare, die dauerhaft bleiben und normal gestylt werden können. Microblading ist Pigmentierung, die alle 1-2 Jahre aufgefrischt werden muss."
  },
  {
    question: "Wie lange dauert der Eingriff?",
    answer: "Eine Augenbrauentransplantation dauert je nach Umfang 2-4 Stunden. Die Zeit verfliegt schnell - Sie können Musik hören oder einen Film schauen."
  },
  {
    question: "Muss ich die transplantierten Haare schneiden?",
    answer: "Ja, da die Haare vom Kopf stammen, wachsen sie etwas schneller als normale Augenbrauenhaare. Ein gelegentliches Trimmen ist erforderlich."
  },
  {
    question: "Ist der Eingriff schmerzhaft?",
    answer: "Nein, die Behandlung erfolgt unter lokaler Betäubung. Sie spüren lediglich ein leichtes Piksen bei der Betäubung."
  },
  {
    question: "Wann sehe ich das endgültige Ergebnis?",
    answer: "Die transplantierten Haare fallen zunächst aus (Shock Loss), wachsen aber nach 3-4 Monaten nach. Das volle Ergebnis sehen Sie nach 9-12 Monaten."
  },
  {
    question: "Kann ich nach der Transplantation Make-up tragen?",
    answer: "In den ersten 10-14 Tagen sollten Sie die Augenbrauenregion nicht schminken. Danach können Sie wie gewohnt Make-up verwenden."
  },
  {
    question: "Wo befindet sich Ihre Klinik?",
    answer: "Unsere Klinik befindet sich in Mönchengladbach und ist ideal erreichbar aus Köln, Düsseldorf, dem Ruhrgebiet und den Niederlanden."
  }
];

export const features = {
  showAIAnalysis: false,
  analysisType: "eyebrow",
  showPricing: true,
  showBeforeAfter: true,
  showTeam: true,
  showClinic: true,
  showEyebrowPatterns: true
};

// Augenbrauenmuster - neu hinzugefügt
export const eyebrowPatterns = [
  {
    id: 1,
    title: "Kahle Augenbrauen",
    description: "Vollständig fehlende oder extrem dünne Augenbrauen, die eine komplette Rekonstruktion erfordern",
    grafts: "500-800",
    sessions: "1 Sitzung",
    image: "/images/Augenbrauen_kahl.webp"
  },
  {
    id: 2,
    title: "Undichte Augenbrauen",
    description: "Lücken oder dünne Stellen in den Augenbrauen, die eine Verdichtung benötigen",
    grafts: "300-500",
    sessions: "1 Sitzung",
    image: "/images/Augenbrauen_undicht.webp"
  },
  {
    id: 3,
    title: "Microblading-Alternative",
    description: "Natürliche und dauerhafte Alternative zu Microblading für definierte Augenbrauen",
    grafts: "400-600",
    sessions: "1 Sitzung",
    image: "/images/Augenbrauen_Microblading.webp"
  }
];

// Behandlungsprozess für Augenbrauen
export const treatmentProcess = [
  {
    id: 1,
    title: "Planung",
    description: "In der Planungsphase wird die Augenbrauenform sorgfältig entworfen und die Anzahl der benötigten Grafts bestimmt. Eine detaillierte Analyse Ihrer Spenderzonen und des Empfängerbereichs ermöglicht eine präzise und individuelle Planung.",
    image: "/images/Augenbrauentransplantation_Planung.svg"
  },
  {
    id: 2,
    title: "Entnahme",
    description: "Bei der Entnahme werden einzelne Haarfollikel aus der Spenderzone (meist am Hinterkopf) entnommen. Diese Follikeleinheiten werden sorgfältig unter dem Mikroskop vorbereitet, um eine hohe Überlebensrate zu gewährleisten.",
    image: "/images/Augenbrauentransplantation_Entnahme.svg"
  },
  {
    id: 3,
    title: "Einpflanzung",
    description: "Die vorbereiteten Haarfollikel werden präzise in die vorher festgelegten Empfängerzonen im Augenbrauenbereich eingesetzt. Dabei wird besonders auf den natürlichen Wuchswinkel und die Verteilung geachtet.",
    image: "/images/Augenbrauentransplantation_Einpflanzung.svg"
  },
  {
    id: 4,
    title: "Endergebnis",
    description: "Nach etwa 6-9 Monaten ist das endgültige Ergebnis sichtbar. Die transplantierten Haare wachsen natürlich und können wie Ihre eigenen Augenbrauen getrimmt und gestylt werden.",
    image: "/images/Augenbrauentransplantation_Endergebnis.svg"
  }
];
